export class TransferRecordModel {
    //收款人
    ToUserName:string;
    //转账金额
    Amount:number;
    //转账时间
    AddTime:string;
}

export class ExchangeRateDto {
    constructor() {
      this.ExchangeRate = 0;
      this.ExchangeRateUp = 0;
      this.UpdateTime = null;
      this.CourseMobile = null;
      this.CoursePC = null;
      this.IsOpen = false;
    }
  
    // 出款汇率
    ExchangeRate: number;
    // 入款汇率
    ExchangeRateUp: number;
    UpdateTime: string;
    CourseMobile: string;
    CoursePC: string;
    IsOpen: boolean;
  }

  /**
 * 生成USDT转账
 */
export class RechardUSDTInput {
    constructor() {
      this.Amount = 0;
      this.Bankid = null;
      this.Commt = null;
      this.Realname = null;
      this.Transactionid = null;
      this.Usdtamount = 0;
      this.ExchangeRate = 1;
    }
  
    Amount: number;
    Bankid: number;
    Realname: string;
    Usdtamount: number;
    Transactionid: string;
    ExchangeRate: number;
    Commt: string;
  }


// WEBPACK FOOTER //
// ./src/models/transferRecord.model.ts